import { Type } from "class-transformer";
import { observable } from "mobx";
import { EntityValidationRules } from "services/validationService";
import Vehicle from "./vehicle";

export const AuthCodeValidationRules: EntityValidationRules<Vignette> = {
  authCode: { isAuthCode: true },
};

export default class Vignette {
  @observable
  authCode?: string;

  @Type(() => Vehicle)
  @observable
  vehicle: Vehicle = new Vehicle();
}
